// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
// import bootstrap from "bootstrap";
// import Parallax from 'parallax-js'
// require ('jquery-parallax.js');
var Masonry = require('masonry-layout');
window.jQuery = $;
window.$ = $;
// import mediumZoom from 'medium-zoom';
require('paroller.js');
// import WOW from'wowjs'
// const WOW = require('wowjs');


// import simpleParallax from 'simple-parallax-js';


// const bootstrap = window.bootstrap = require('bootstrap');
// import { createPopper } from '@popperjs/core';
// var parallax_images = document.getElementsByClassName('parallax');
// new simpleParallax( parallax_images,{
//     overflow: false
//     // scale: 1.05
//     // orientation: 'right'
// });

var stickyHeaderHeight = 150 ;
if (window.matchMedia("(max-width: 768px)").matches){
    stickyHeaderHeight = 0 ;
}

if(document.querySelector('.grid')){
    var msnry = new Masonry( '.grid', {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
}

document.querySelectorAll('.my-tooltip').forEach(function (el) {

    let tooltip = new bootstrap.Tooltip(el, {
        html: true,
        title: 'Chargement...',
        trigger: 'hover'
    });

    let loaded = false;

    el.addEventListener('mouseenter', function () {

        if (loaded) return;

        let data = {
            action: 'ajax_get_booking_next_step',
            type: el.dataset.type,
            value: el.dataset.value,
            parent: el.dataset.value,
            level: el.dataset.level,
            current_user: el.dataset.currentUser,
            users: el.dataset.users,
            name: el.dataset.name,
        };

        $.ajax({
            url: 'ton_url_ajax',
            type: 'POST',
            data: data,
            success: function (response) {

                let description = response.description;

                // Mettre à jour CE tooltip uniquement
                el.setAttribute('data-bs-original-title', description);

                let instance = bootstrap.Tooltip.getInstance(el);
                instance.setContent({
                    '.tooltip-inner': description
                });

                // refresh si visible
                instance.hide();
                instance.show();

                loaded = true;
            }
        });

    });

});

// var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
// var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
//   return new bootstrap.Dropdown(dropdownToggleEl)
// })


$(document).ready(function() {

    $('#block-16').find('a.contact-phone').attr('data-trk-click-tel', '05 48 22 01 60');

    /**
     * Anchor smooth scroll
     */
    $('a[href*="#"]')
    .not('[href="#"]')
    .not('.list-group-item-action')
    .not('[href="#0"]')
    .on('click', function(event) {

        console.log('click scroll?')
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                document.documentElement.scrollTo({
                    top: target.offset().top - stickyHeaderHeight,
                    behavior: "smooth"
                });
            }
        }
    });

    $(window).on('load', function(){
        if(window.location.hash) {
            var target = $(window.location.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                document.documentElement.scrollTo({
                    top: target.offset().top - stickyHeaderHeight - 60,
                    behavior: "smooth"
                });
            }
        }
    });


    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        var $panel = $(this).closest('.accordion-item');
        document.documentElement.scrollTo({
            top: $panel.offset().top - stickyHeaderHeight,
            behavior: "smooth"
        });
    });
    /**
     * Fix menu level 3 
     * https://wordpress.stackexchange.com/questions/308953/multi-level-bootstrap-navigation-menu-in-wordpress
     */
    $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
        if (!$(this).next().hasClass('show')) {
          $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('_show');
      
      
        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
          $('.dropdown-submenu .show').removeClass("show");
          $('.dropdown-submenu ._show').removeClass("_show");
        });
      
      
        return false;
      });


    //Clone burger icon to overlay menu
    $('.navbar-fixed-opened').on('show.bs.collapse', function () {
        $('.navbar-closer').remove();
        $('.navbar-fixed-opened').prepend(`<button class="navbar-toggler navbar-closer" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="true" aria-label="Toggle navigation">
        <i class="fa fa-lg fa-times"></i></button>`);
    }) ;

    // Close menu when Escape
    $(document).on('keydown', function(e) {
        if (e.key == "Escape") {
            $('#navbarMain').collapse('hide');
        }
    });

    //Wow
    if('function' === typeof WOW){
        new WOW().init();
    }
    

    // Sticky menu
    //if (window.matchMedia("(min-width: 768px)").matches && !$('body').hasClass('page-id-598')) {
    if ( !$('body').hasClass('page-id-598')) {
         //let widget = $('.topbar-center') ;
        window.addEventListener('scroll', function() {
           return ;
            if (window.scrollY > 400) {
                $('#navbar-main')
                    .addClass('fixed-top')
                let navbar_height = document.querySelector('.navbar').offsetHeight;
                document.body.style.paddingTop = navbar_height + 'px';
               // widget.addClass('sticky');
               
            } else {
                $('#navbar-main')
                    .removeClass('fixed-top');
                    //.find(widget).remove();
                document.body.style.paddingTop = '0';
               // widget.removeClass('sticky');
            } 
        });
    }

    window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
            $('.reservation-bar').addClass('is-shown')
        } else {
            $('.reservation-bar').removeClass('is-shown')
        } 
    });

    $('.dropdown-toggle').dropdown();
    // mediumZoom('[data-zoomable]');

    

    // jarallaxVideo();
    jarallax(document.querySelectorAll('.jarallax'), {
        speed: 0.2
    });
    $("[data-paroller-factor]").paroller(); 


    // Menu
    // $(".dropdown").hover(function(){
    //     var dropdownMenu = $(this).children(".dropdown-menu");
    //     if(dropdownMenu.is(":visible")){
    //         dropdownMenu.parent().toggleClass("open");
    //     }
    // });


    // $(document).on('click', '.navbar .dropdown-toggle', function(){
    //     if (window.matchMedia("(min-width: 992px)").matches) {
    //         window.location.href= $(this).attr('href');
    //     }
    // });

      // Search form full screen [search_full_screen]
      $(document).on('click', '#search-full-screen__toggle', function(){
        $('#search-full-screen__target')
            .prepend(`<button class="navbar-toggler agencea-overlay__close" type="button" aria-controls="search-full-screen__form" aria-expanded="true" aria-label="Fermer">
        <i class="fa fa-lg fa-times"></i></button>`)
            .addClass('shown');
    });

    $(document).on('click', '.agencea-overlay__close', function(){
        $('.agencea-overlay')
            .removeClass('shown')
            .find('.agencea-overlay__close').remove();
           
    });
   



    // Counters
    $('.count').each(function () {
        $(this).css('opacity', 1);
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 4000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
    });


      //Scroll back to top
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 150;
		// var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			document.documentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            })
			return false;
		});

    /**
     * Map dealers
     */

    // if($('#contact_map').length > 0){
    

    //     $.post(ajaxurl, {'action':'geocode_contact_address'}, function(response){
    //         if(response.lat_lng != ""){
    //             var contactmap = L.map('contact_map').setView([response.lat_lng.lat, response.lat_lng.lng], 15);

    //             L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
    //                 maxZoom: 18,
    //                 id: 'mapbox/streets-v11',
    //                 tileSize: 512,
    //                 zoomOffset: -1
    //             }).addTo(contactmap);
           
    //             var marker = L.marker([response.lat_lng.lat, response.lat_lng.lng], {title:response.name+'<br>'+response.address}).addTo(contactmap);
    //             marker.bindPopup(response.name+'<br>'+response.address).openPopup();
                    
    //         }
        
    //     });
     
    // }

   
});
